import axios from 'axios'
import { mockableLinks } from '../constants/config';

// import { Message, MessageBox } from 'element-ui'
//import store from '../store'
//import { getToken } from '@/utils/auth'

//Create Axios instance
const service = axios.create({
  baseURL:  process.env.VUE_APP_BASE_API, // base of API_ URL,
  Timeout: 5000, // request timeout
  
})


let rk = (len) =>{ 
    let text = ""
    let chars = "abcdefghijklmnopqrstuvwxyz1234567890" 
    for( let i=0; i < len; i++ ) {
            text += chars.charAt(Math.floor(Math.random() * chars.length))
    } 
    return text; 
};

// make sure to add here list of api 
// that response data does not frequently change
// analyze before adding


const getToken = () => localStorage.getItem('ecmtctoken');
const get_current_usid =() => localStorage.getItem('ec_current_usid');
const get_override_cifid  =() => localStorage.getItem('override_cifid');
  
let cachedData = null;
let currentRequest_URL = "";

const getCachedData = (url) =>{  
  let mockable = mockableLinks.find(api => api.url === url); 
  if(mockable !== undefined && mockable !== null) {
    currentRequest_URL = "";
    let localDataTimestamp = localStorage.getItem(mockable.url + '_local_data_timestamp');
      let currentTimeStamp = Date.now();
      let secondsPassed = (currentTimeStamp - localDataTimestamp) / 1000;
     if(secondsPassed < mockable.ttl_in_seconds) {
          let localData  = localStorage.getItem(mockable.url + '_local_data'); 
          console.log("still fresh data " + mockable.url + " . " + secondsPassed + " have passed. getting from local storage")
          //return data from the local storage 
          if(localData !== undefined){
            return  localData;
          } 
     } 
  }
  return null;
};

//Request interceptor 
service.interceptors.request.use(
  config => {
   //console.log(config.url)
    cachedData = getCachedData(config.url);
    if(cachedData !== undefined && cachedData !== null) {
        currentRequest_URL = config.url; 
        config.url = "http://localhost/" + config.url; 
        
    }

    if(config.url.split("?").length > 1) {
      config.url = config.url + "&rk=" + rk(20); //add random key to prevent caching
    } else {
      config.url = config.url + "?rk=" + rk(20); //add random key to prevent caching
    } 
    if (getToken() != null && getToken() !== '') {
      config.headers ['ECAPP-TWXHEADER'] = getToken() // let each request carry a custom token. Please modify it according to the actual situation
    }
    if(get_current_usid() != null && get_current_usid() !== "") {
      config.headers ['ec_current_usid'] = get_current_usid() 
    }
    if(get_override_cifid() != null && get_override_cifid() !== "") {
      config.headers ['ec_override_cifid'] = get_override_cifid() 
    }
    return config
  },
  error => {
    // Do something with request error
    console.log("here");
    console.log(error) // for debug
    Promise.reject(error)
  }
)


//Response interceptor
service.interceptors.response.use(
  response => {
   // console.log(response);
    /**
     *If the code is not 20000, it is a mistake and can be modified according to your own business
     */
    const res = response;
    if (res.status === 502) { 
      console.log("remove session");
      localStorage.removeItem('ecmtctoken'); 
      location.replace('/');
      return Promise.reject('error')
    } else {


      if(response.status === 200) { 
          let apiLink = response.config.url.split("?");
          if(apiLink.length > 1) {
            apiLink = apiLink[0];
          } 
          //save data  in the local storage
          let mockable = mockableLinks.find(api =>   api.url === apiLink ); 
          if(mockable !== undefined && mockable !== null) { 
                localStorage.setItem(mockable.url + '_local_data', JSON.stringify(response.data));
                localStorage.setItem(mockable.url + '_local_data_timestamp', Date.now());
          } 
      }

      return response;
    }
  },
  error => {   

    let apiLink = error.config.url.split("?");
    if(apiLink.length > 1) {
      apiLink = apiLink[0];
    } 
    apiLink = apiLink.replace("http://localhost/", "");

    if (error.response !== undefined && error.response.status === 502) { 
      console.log("remove session");
      localStorage.removeItem('ecmtctoken'); 
      location.replace('/');
    }

    cachedData = getCachedData(apiLink);
    if(cachedData !== undefined && cachedData !== null) { 

        return Promise.resolve({
          data: JSON.parse(cachedData)
        });
    }

  /*  Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    }) */
    
    return Promise.reject(error)
  }
)
  
 
 
 

export default service;